import React from "react";
import { Zap, Sun, Ruler, KeyRound } from "lucide-react";
import { SITE } from "@/constants/testIds";

const values = [
  {
    icon: Zap,
    title: "Mühendislik & Elektrik",
    desc: "Güçlü altyapı, kesintisiz enerji ve yüksek teknoloji standartları.",
    code: "01",
  },
  {
    icon: Sun,
    title: "Yenilenebilir Enerji",
    desc: "Güneş enerjisi (GES) sistemleri ile çevre dostu ve ekonomik çözümler.",
    code: "02",
  },
  {
    icon: Ruler,
    title: "Mimari & Tasarım",
    desc: "Modüler, estetik ve işlevsel yaşam ve çalışma alanlarının tasarımı.",
    code: "03",
  },
  {
    icon: KeyRound,
    title: "Anahtar Teslim Projeler",
    desc: "Planlamadan devreye almaya, uçtan uca proje yönetimi.",
    code: "04",
  },
];

export const Values = () => {
  return (
    <section id="values" className="relative py-24 md:py-32 border-b border-neutral-900">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-6 h-px bg-[#ff5a00]" />
              <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#ff5a00]">
                Öne Çıkan Değerler
              </span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight max-w-3xl">
              Uzmanlık dört sütunda, <span className="italic font-light text-neutral-400">tek çatı altında</span>.
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md text-sm md:text-base">
            Enerji üretiminden modüler yapıya kadar tüm mühendislik disiplinlerini bir araya getiriyoruz.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-900">
          {values.map((v, i) => {
            const Icon = v.icon;
            return (
              <div
                key={i}
                data-testid={SITE.valueCard(i)}
                className="value-card bg-[#0a0a0b] border border-neutral-900 p-8 lg:p-10 min-h-[280px] flex flex-col justify-between group cursor-pointer"
              >
                <div className="flex items-start justify-between">
                  <Icon size={32} strokeWidth={1.4} className="value-icon text-neutral-200" />
                  <span className="font-mono-tech text-[10px] tracking-[0.3em] text-neutral-600">
                    {v.code}
                  </span>
                </div>
                <div>
                  <h3 className="font-display font-semibold text-xl md:text-2xl tracking-tight text-white mb-3">
                    {v.title}
                  </h3>
                  <p className="text-sm text-neutral-400 leading-relaxed">
                    {v.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Values;
